import React from 'react'

import { CobrandingLogo } from '@frame/ui-components/cobranding-logo'
import { ContactUs } from '@frame/ui-components/contact-us'
import { BaseWidgetHeader } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { useStore } from '@frame/lib/stores/useStore'
import { getTextForVerificationType, getVerifierDisplayName } from '@frame/lib/utils/session'
import { DataAttribute } from '@frame/types'

export function Fallback() {
  const { verifierName, verificationType, verifierType, tenantPropertyName } = useStore((state) => ({
    verifierName: state.session?.originating_party_display_name,
    verificationType: state.session?.verification_type,
    tenantPropertyName: state.session?.configuration?.cobranding?.tenant_property?.property_name,
    verifierType: state.session?.verifier_type,
  }))
  const incomeOrEmployment = getTextForVerificationType(verificationType)
  const displayName = getVerifierDisplayName(verifierType, verifierName, tenantPropertyName)

  return (
    <>
      <BaseWidgetHeader />
      <Body data-cy={DataAttribute.SCREEN_TERMINAL_FALLBACK} paddingTopOverride={0} className="p-5">
        <CobrandingLogo />
        <H2 className="my-5 text-center">We've got you covered!</H2>
        <P className="mb-4">
          We had trouble connecting to your account. Truework's verfication experts will reach out to your HR team to
          verify your {incomeOrEmployment} and securely share your details with {displayName}.
        </P>
        <ContactUs />
      </Body>
    </>
  )
}
